import { Injectable } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../services/api.service';
import { Store } from '../store';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class CmsService {
    env = environment;

    constructor(
        private http: HttpClient,
        private apiService: ApiService,
        private store: Store,
        private toastrService: ToastrService
    ) {}

    getAll() {
        return this.http.get(this.env.apiPath + 'cms/admin/pages', this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

    getByID(id) {
        return this.http.get(this.env.apiPath + 'cms/' + id, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

    create(cmsData) {
        const dataToSend = {
            data: cmsData,
        };
        return this.http.post(this.env.apiPath + 'cms/create', dataToSend, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                this.toastrService.success('CMS snippet created');
                return data;
            })
        );
    }
    update(cmsData) {
        const dataToSend = {
            data: cmsData,
        };
        return this.http.post(this.env.apiPath + 'cms/update', dataToSend, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                this.toastrService.success('CMS snippet updated');
                return data;
            })
        );
    }

    getSettings() {
        return this.http.get(this.env.apiPath + 'settings', this.apiService.getHttpOptions()).pipe(
            tap((data: any) => {
                this.store.set('settings', data.data);
            }),
            map((data) => data.data)
        );
    }
}
